import { 
  PROFILE_ERROR,
  PROFILE_SUCCESS,
  EDIT_PROFILE,
  EDIT_AVATAR,
  EDIT_LOGIN,
  RESET_PROFILE_FLAG } from "./actionTypes"

export const editAvatar = user => {
  return {
    type: EDIT_AVATAR,
    payload: { user },
  }
}

export const editLogin = userLogin => ({
  type: EDIT_LOGIN,
  payload: { userLogin },
});

export const editProfile = user => {
  return {
    type: EDIT_PROFILE,
    payload: { user },
  }
}

export const profileSuccess = msg => {
  return {
    type: PROFILE_SUCCESS,
    payload: msg,
  }
}

export const profileError = error => {
  return {
    type: PROFILE_ERROR,
    payload: error,
  }
}

export const resetProfileFlag = error => {
  return {
    type: RESET_PROFILE_FLAG,
  }
}
